export default {
    state: {
    },
    mutations: {
    },
    actions: {
        async getGuestsReportInfo({dispatch}, obj) {
            return await dispatch('apiQuery', {
                method:`/reports/guest?date_begin=${obj.date_begin}&date_end=${obj.date_end}`
            })
        }
    },
    getters: {
    }
}